// extracted by mini-css-extract-plugin
export default {"r_l":"c75f1e6639 _89ce0dd436","t":"_38399932ab"};